import { render, staticRenderFns } from "./pwa_article.vue?vue&type=template&id=711a927c&scoped=true&"
import script from "./pwa_article.vue?vue&type=script&lang=js&"
export * from "./pwa_article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711a927c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711a927c')) {
      api.createRecord('711a927c', component.options)
    } else {
      api.reload('711a927c', component.options)
    }
    module.hot.accept("./pwa_article.vue?vue&type=template&id=711a927c&scoped=true&", function () {
      api.rerender('711a927c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/texts/pwa_article.vue"
export default component.exports